module.exports = __webpack_public_path__ + "static/media/relativoNovo.89640c91.png";